<template>
  <div class="MyAccountPage_PersonalDetail">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>

    <template v-else>
      <template v-if="hasZuoraAccount">
        <my-account-personal-detail
          :personal-detail="profile.personalDetail"
          @personal-detail-change="setPersonalDetailItem($event)"
        />

        <div class="DisableToUpdateAddressTips" v-if="!ableToUpdateAddress">
          <p>
            {{ $t('myaccount.personalDetail.disableToUpdateAddress', 'We are currently processing your latest order and are therefore not able to change your delivery details. You will be able to edit your delivery details after processing.') }}
          </p>
        </div>

        <my-account-address
          :countries="countries || []"
          :shipping="profile.shipping || {}"
          :billing="profile.billing || {}"
          :has-billing="profile.hasBilling"
          @shipping-change="setShippingAddressItem($event)"
          @billing-change="setBillingAddressItem($event)"
        />

        <div
          class="privacyDeclaration"
          v-html="$t('myaccount.privacyDeclaration.text')">
        </div>
      </template>

      <template v-else>
        <div class="PersonalDetail_header">
          <h3 class="form_title">
            {{ $t('myaccount.personalDetail.title', 'Contact') }}
          </h3>
        </div>

        <p class="empty-data">
          {{ $t('myaccount.personalDetails.body.emptyData', ' Sorry, you do not have zuora account or your personal details have not synchronize yet!') }}
        </p>
      </template>
    </template>
  </div>
</template>

<script>
  import MyAccountPersonalDetail from 'components/MyAccountPersonalDetail'
  import MyAccountAddress from 'components/MyAccountAddress'
  import { mapState, mapMutations } from 'vuex'
  import { extractErrorMessage } from 'utilities/common'

  export default {
    name: 'personal-details',

    components: {
      MyAccountPersonalDetail,
      MyAccountAddress
    },

    data () {
      return {
        isLoading: true,
        hasZuoraAccount: false
      }
    },

    computed: {
      ...mapState('account', {
        profile: state => state.profile,
        ableToUpdateAddress: state => state.profile.personalDetail.ableToUpdateAddress
      }),
      ...mapState('culture', ['countries'])
    },

    methods: {
      ...mapMutations('account', ['setShippingAddressItem', 'setBillingAddressItem', 'setPersonalDetailItem'])
    },

    created () {
      this.$store.dispatch('account/fetchProfile').then((profile) => {
        this.hasZuoraAccount = !!profile
        this.isLoading = false
      }).catch(error => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
    }
  }
</script>

<style lang="scss">
  .MyAccountPage_PersonalDetail {
    .PersonalDetail_header {
      border-bottom: .01rem solid #9b9b9b;
      margin-bottom: 0;
      padding: 0 .07rem .12rem .15rem;
    }

    .form_title {
      font-size: .24rem;
      line-height: 1;
      color: #252525;
    }

    .AppButton {
      width: 100%;
    }

    .multiselect {
      min-height: 0;

      &__tags {
        padding: 0 .4rem .1rem .15rem;
        font-weight: 500;
        border-width: 0 0 .02rem 0;
        border-color: $border-color;
      }

      &__single {
        font-size: .18rem;
        font-weight: 500;
        line-height: .25rem;
      }

      &__input {
        font-size: .18rem;
        line-height: .25rem;
      }
    }

    .Form_group-choice {
      padding: 0 .15rem;
      margin-top: .28rem;
    }

    .tip-error {
      padding: .05rem .15rem;
    }

    .SelectGroup.error {
      .multiselect__tags {
        border-color: $pink;
      }
    }

    .DisableToUpdateAddressTips {
      border: .01rem solid #de7815;
      background-color: #fdf5d7;
      margin-top: .2rem;

      p {
        padding: .15rem .16rem .25rem;
        color: #de7815;
        font-size: .16rem;
        line-height: .22rem;
      }
    }
  }
</style>
